import React from 'react';
import { Grid, Input } from 'semantic-ui-react';

export default function GaugeComponent({ value, onChange, disabled, onBlur, attributeObj = {} }) {
  const { showQtField = false } = attributeObj || {};
  const gaugeValue = value || { ft: '', in: '', qt: '' };

  const onFtChange = (e) => {
    let val = parseInt(e.target.value);
    if (val > 9999) {
      val = 9999;
    } else if (val < 0) {
      val = 0;
    }
    const newDateTimeValue = { ...gaugeValue, ft: val };
    onChange(newDateTimeValue);
  };

  const onInChange = (e) => {
    let val = parseInt(e.target.value);
    if (val > 11) {
      val = 11;
    } else if (val < 0) {
      val = 0;
    }
    const newDateTimeValue = { ...gaugeValue, in: val };
    onChange(newDateTimeValue);
  };

  const onQtChange = (e) => {
    let val = parseInt(e.target.value);
    if (val > 3) {
      val = 3;
    } else if (val < 0) {
      val = 0;
    }
    const newDateTimeValue = { ...gaugeValue, qt: val };
    onChange(newDateTimeValue);
  };

  return (
    <div>
      <Grid columns={showQtField ? 3 : 2}>
        <Grid.Column>
          <Input
            label={{ basic: true, content: 'ft' }}
            labelPosition="right"
            type="number"
            onChange={onFtChange}
            onBlur={onBlur}
            value={gaugeValue?.ft}
            disabled={disabled}
            min={0}
            max={9999}
            placeholder="0000"
          />
        </Grid.Column>
        <Grid.Column>
          <Input
            type="number"
            label={{ basic: true, content: 'in' }}
            labelPosition="right"
            onChange={onInChange}
            onBlur={onBlur}
            value={gaugeValue?.in}
            disabled={disabled}
            min={0}
            max={11}
            placeholder="00"
          />
        </Grid.Column>
        {showQtField && (
          <Grid.Column>
            <Input
              type="number"
              label={{ basic: true, content: 'qt' }}
              labelPosition="right"
              onChange={onQtChange}
              onBlur={onBlur}
              value={gaugeValue?.qt}
              disabled={disabled}
              min={0}
              max={3}
              placeholder="0"
            />
          </Grid.Column>
        )}
      </Grid>
    </div>
  );
}
